export default "__VITE_ASSET__b79bdda9__"